<template>
  <div class="sanitas-search-result">
    <article class="card">
      <div class="content">
        <a
          :href="href"
          target="_self"
          rel="noopener"
          onclick="if (typeof s !== 'undefined'){s.tl(this,'e','ComSearchResultClick',null,'navigate')}"
        >
          <div class="titleanddescription">
            <h3 id="title" class="title" v-html="title"></h3>
            <p
              id="description"
              :class="{
                'description': true,
                'document-description': type === 'document',
              }"
              v-html="description"
            ></p>
          </div>
        </a>
        <dotcom-breadcrumb
          :navigation-links="breadcrumbdata"
          variant="search"
        />
      </div>
    </article>
  </div>
</template>

<script>
import DotcomBreadcrumb from '@/modules/breadcrumb/Breadcrumb'

export default {
  name: 'SanitasSearchResult',
  components: {
    DotcomBreadcrumb,
  },
  props: {
    type: {
      type: String,
      default: '',
    },

    /**
     * link/page that will be opened when the user taps the search result
     */
    href: {
      type: String,
      default: '',
    },

    /**
     * the title of the result
     *
     * You can highlight portions of the title by encapsulating the wanted
     * part with a ```<strong>_content_to_highlight_</strong>```
     *
     * Please note that the String passed here will be directly injected as HTML
     * in the document
     **/
    title: {
      type: String,
      default: '',
    },

    /**
     * a small description shown underneath the title.
     *
     * You can highlight portions of the description by encapsulating the wanted
     * part with a ```<strong>_content_to_highlight_</strong>```
     *
     * Please note that the String passed here will be directly injected as HTML
     * in the document
     **/
    description: {
      type: String,
      default: '',
    },
    category: {
      type: String,
      default: '',
    },
    breadcrumbdata: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="postcss">
.sanitas-search-result {
  display: block;
  text-decoration: none;
  border: 0;

  &:hover {
    border: 0;
    .description,
    .title {
      color: var(--c-primary-color-2);
    }
  }

  .card {
    display: flex;
    padding: var(--spacing-4) 0;
    background-color: var(--c-primary-neutral-3);
  }

  .content {
    flex-grow: 20;
    overflow: hidden;

    .dotcom-icon {
      width: 12px;
      height: 12px;
      vertical-align: middle;
      padding-right: var(--spacing-1);
    }
  }

  .title {
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: 0;
    color: var(--c-primary-neutral-1);
    margin: 0;
    margin-right: var(--spacing-2);
    word-break: break-all;
  }

  .description {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: normal;
    color: var(--c-primary-neutral-1);
    margin: 0;
  }

  .title,
  .description {
    strong {
      background-color: var(--c-primary-color-1-c);
    }
  }

  .document-description {
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    line-height: 1.35;
    letter-spacing: normal;
    color: var(--c-primary-neutral-1);

    margin: 0;
    display: inline-block;
  }
}
</style>
